var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.791,
    height: 13.312,
    viewBox: "0 0 14.791 13.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Word",
    transform: "translate(-4 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13229",
    "data-name": "Path 13229",
    d: "M24.448,6h-9.8A.645.645,0,0,0,14,6.645V9.329H25.093V6.645A.645.645,0,0,0,24.448,6Z",
    transform: "translate(-6.302)",
    fill: "#2d92d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13230",
    "data-name": "Path 13230",
    d: "M14,33.054v2.663a.645.645,0,0,0,.644.645h9.8a.645.645,0,0,0,.645-.645V33.054Z",
    transform: "translate(-6.302 -17.05)",
    fill: "#2150a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13231",
    "data-name": "Path 13231",
    d: "M14,15H25.093v3.329H14Z",
    transform: "translate(-6.302 -5.674)",
    fill: "#2d83d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13232",
    "data-name": "Path 13232",
    d: "M14,24H25.093v3.346H14Z",
    transform: "translate(-6.302 -11.347)",
    fill: "#2e70c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13233",
    "data-name": "Path 13233",
    d: "M10.774,21.4H4.622A.622.622,0,0,1,4,20.774V14.622A.622.622,0,0,1,4.622,14h6.152a.622.622,0,0,1,.622.622v6.152A.622.622,0,0,1,10.774,21.4Z",
    transform: "translate(0 -5.042)",
    fill: "#00488d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13234",
    "data-name": "Path 13234",
    d: "M11.62,19l-.572,2.686L10.415,19H9.607l-.653,2.769L8.364,19H7.641l.867,3.7h.87l.633-2.843.634,2.843h.832l.867-3.7Z",
    transform: "translate(-2.295 -8.193)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.5fe038dd820ce00510b0e675e802b82a.svg";
export { ForwardRef as ReactComponent };